export const translationModeration_sv = {
  blockVisitor: "Blockera besökare",
  blockVisitorTitle: "Blockera den här besökaren?",
  blockVisitorDescription:
    "De kan inte längre se eller använda chatten på någon av er organisations chatbotar. Ni kan häva blockeringen när som helst under Inställningar, Blockerade besökare.",
  blockDuration: "Blockera i",
  blockDays1: "1 dag",
  blockDays7: "7 dagar",
  blockDays30: "30 dagar",
  blockDays90: "90 dagar",
  blockConfirm: "Blockera besökare",
  cancel: "Avbryt",
  visitorBlocked: "Besökaren är blockerad.",
  visitorAlreadyBlocked: "Den här besökaren är redan blockerad.",
  visitorNotBlockable: "Bara livesamtal med en känd besökare kan blockeras.",
  blockFailed: "Besökaren kunde inte blockeras. Försök igen.",
  moderationFlagged: "Moderering flaggade {count} meddelanden: {categories}.",
  moderationFlaggedOne: "Moderering flaggade ett meddelande: {categories}.",
  moderationWouldBlock:
    "Moderering skulle ha blockerat den här besökaren, men blockerade dem inte automatiskt.",
  moderationBlockedUntil: "Den här besökaren är blockerad till {date}.",
  categoryRude: "Oartig",
  categoryOfftopic: "Utanför ämnet",
  categoryNonsense: "Nonsens",
  categoryAbuse: "Trakasserier",
  categoryAttack: "Attackförsök",
  categorySpam: "Spam",
  badgeBlocked: "Blockerad",
  badgeWouldBlock: "Skulle blockera",
  badgeFlagged: "Flaggad",
  filterMisuse: "Missbruk",
  filterWouldBlock: "Skulle blockera",
  pageTitle: "Blockerade besökare",
  pageDescription:
    "Besökare som hålls borta från er organisations chattar, blockerade av ert team eller av moderering. Bara ett fingeravtryck av varje adress sparas, aldrig själva adressen.",
  columnReason: "Orsak",
  columnConversation: "Samtal",
  columnBlocked: "Blockerad",
  columnExpires: "Till",
  columnActions: "Åtgärder",
  reasonManual: "Av ert team",
  reasonAttack: "Attackförsök",
  reasonAbuse: "Upprepade trakasserier",
  openConversation: "Öppna samtal",
  unblock: "Häv blockering",
  unblockTitle: "Häva blockeringen av den här besökaren?",
  unblockDescription: "De kan använda chatten igen direkt.",
  unblocked: "Blockeringen är hävd.",
  unblockFailed: "Blockeringen kunde inte hävas. Försök igen.",
  noBlocks: "Inga besökare är blockerade.",
  loadFailed: "Blockerade besökare kunde inte laddas.",
  exemptionsTitle: "Blockeras aldrig automatiskt",
  exemptionsDescription:
    "Adresser som moderering aldrig blockerar på egen hand, till exempel ert kontor eller en säkerhetstestare ni anlitat. Ert team kan fortfarande blockera dem.",
  exemptionAddress: "IP-adress",
  exemptionName: "Namn",
  addExemption: "Lägg till adress",
  removeExemption: "Ta bort",
  removeExemptionLabel: "Ta bort {name}",
  exemptionAdded: "Adressen är undantagen.",
  exemptionInvalid: "Ange en giltig IP-adress och ett namn.",
  exemptionExists: "Den adressen är redan undantagen.",
  exemptionFailed: "Adressen kunde inte sparas. Försök igen.",
  noExemptions: "Inga adresser är undantagna.",
  loadingMore: "Laddar fler",
};
